import axios from 'axios';

const clearNotifications = function () {
  axios
    .post('/notifications/mark_notifications_as_read.json')
    .then(() => {
      $('#notification-counter').animate(
        {
          opacity: 0,
        },
        1200
      );
      $('#notification-label').animate(
        {
          opacity: 0,
        },
        1200
      );
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

document.addEventListener('turbolinks:load', function () {
  $('#open_notification').on('click', function () {
    if ($('#notification-counter').text()) {
      clearNotifications();
    }
  });

  $('.notifications-daterange').daterangepicker({
    autoUpdateInput: false,
    showDropdowns: true,
    timePicker: true,
    timePickerSeconds: true,
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'DD-MM-YYYY hh:mm:ss A',
    },
  });

  $('.notifications-daterange').on(
    'apply.daterangepicker',
    function (ev, picker) {
      $(this).val(
        `${picker.startDate.format(
          'DD-MM-YYYY hh:mm:ss A'
        )} - ${picker.endDate.format('DD-MM-YYYY hh:mm:ss A')}`
      );
      $(this).trigger('change');
    }
  );

  $('.notifications-daterange').on('cancel.daterangepicker', function () {
    $(this).val('');
  });
});
